export const environment = {
    "aws": {
        "Auth": {
            "authenticationFlowType": "USER_PASSWORD_AUTH",
            "cookieStorage": {
                "domain": ".examsoft.com",
                "expires": 365,
                "path": "/",
                "secure": true
            },
            "identityPoolId": "ap-southeast-2:e2773ed6-1fbd-4e8b-b64e-1f24e721ce53",
            "identityPoolRegion": "ap-southeast-2",
            "region": "ap-southeast-2",
            "userPoolId": "ap-southeast-2_Y0fo5x9KQ",
            "userPoolWebClientId": "3u1cmb6f40fhfd4q169lod1tob"
        },
        "oauth": {
            "domain": "cog011apauprod.auth.ap-southeast-2.amazoncognito.com",
            "options": {
                "AdvancedSecurityDataCollectionFlag": true
            },
            "redirectSignIn": "window.location.origin",
            "redirectSignOut": "window.location.origin",
            "responseType": "code",
            "scope": [
                "phone",
                "email",
                "profile",
                "openid",
                "aws.cognito.signin.user.admin"
            ]
        }
    },
    "esLogin": "https://login-au.examsoft.com/",
    "macDownloadUrl": "https://releases.examsoft.com/Examplify/Examplify_LATEST_mac.dmg",
    "metadata": {
        "application_code": "phx",
        "geographic_code": "ap",
        "instance_index": "011"
    },
    "phxLogoutUrl": "https://enterprise-au.examsoft.com/logout",
    "phxUrl": "https://enterprise-au.examsoft.com",
    "production": true,
    "urls": {
        "institutionApiUrl": "https://cog011-api-prod.examsoft.com/institutions",
        "marsAssessmentUrl": "https://mrs011-api-prod.examsoft.com",
        "marsSOReportUrl": "https://mrs011-api-prod.examsoft.com",
        "paypalAPIUrl": "https://www.paypal.com/sdk/js?client-id=AcQgSLsCwV9o5VNzgvQoff3SUhcKkkTnF3sf3q-wFmhTTAvqQlMNxWMliip9Pz9sk2P5XRzSsQIWGv0u&disable-funding=credit,card",
        "studentPortalAPIUrl": "https://phx011-api-prod.examsoft.com"
    },
    "winDownloadUrl": "https://releases.examsoft.com/Examplify/Examplify_LATEST_win.exe"
};